import React from 'react';
import { Button } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';

export const ButtonSecurePayment = ({sx, onClick}) => {
    return (
         <Button 
            variant="outlined" 
            startIcon={<CreditCardIcon />}
            sx={{ my: 2 , minWidth:180,  ...sx,}}
            onClick={onClick}
        >
            Secure Payment
          </Button>
    );
};
